import { render, staticRenderFns } from "./PixellotTable.vue?vue&type=template&id=4e1def2c&lang=pug&"
import script from "./PixellotTable.vue?vue&type=script&lang=js&"
export * from "./PixellotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1def2c')) {
      api.createRecord('4e1def2c', component.options)
    } else {
      api.reload('4e1def2c', component.options)
    }
    module.hot.accept("./PixellotTable.vue?vue&type=template&id=4e1def2c&lang=pug&", function () {
      api.rerender('4e1def2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/table/PixellotTable.vue"
export default component.exports